module.exports = __webpack_public_path__ + "img/横向中线对齐3.383eee5b.svg";